import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../../../../hooks/useTypedSelector";
import {
  addorRemoveMemberRider,
  addOrRemoveRider,
  setSelectedMembers,
  updateRiderSumInsured,
} from "../../../../modules/quotes.slice";
import { RiderInterface } from "../../../../services/Quotes.service";
import RiderSelect from "./RiderSelect";
import { useGetProposalDetailsQuery } from "../../../../services/Proposal.service";

interface RiderCardProps {
  rider: RiderInterface;
  isDisabled?: boolean;
  isFetching?: boolean;
  refetchRiders: () => any;
  isEnabled: boolean;
}

const RiderCard: React.FC<RiderCardProps> = ({
  rider,
  isDisabled,
  isFetching,
  isEnabled,
}) => {
  const dispatch = useDispatch();
  const { selectedRiders, selected_members_rider } = useTypedSelector(
    (state) => state.quote
  );
  const { members, quote_data } = useGetProposalDetailsQuery();

  const isRiderSelected = selectedRiders.some(
    (item) => item.ADD_ON_ID === rider.ADD_ON_ID
  );

  const selectedRider = selectedRiders.find(
    (item) => item.ADD_ON_ID === rider.ADD_ON_ID
  );

  const sum_insured = selectedRiders.find(
    (item) => item.ADD_ON_ID === rider.ADD_ON_ID
  )?.SUM_INSURED;


  const lastSelectedSIRef = useRef(selectedRider?.SUM_INSURED || null);

  const [selectedSumInsuredPA, setSelectedSumInsuredPA] = useState(() => {
    return selectedRider?.SUM_INSURED ||
      lastSelectedSIRef.current ||
      (rider?.VALUE?.split(",")[0] || "1X");
  });

  // useEffect(() => {
  //   if (selectedRider?.SUM_INSURED && selectedRider.SUM_INSURED !== lastSelectedSIRef.current) {
  //     lastSelectedSIRef.current = selectedRider.SUM_INSURED;
  //   }
  // }, [selectedRider]);

  useEffect(() => {
    if (selectedRider?.SUM_INSURED) {
      setSelectedSumInsuredPA(selectedRider.SUM_INSURED);
    }
  }, [selectedRider]);

  useEffect(() => {
    if (quote_data?.ADD_ONS?.length) {
      const updatedSelectedMembers = { ...selected_members_rider };

      quote_data.ADD_ONS.forEach((addon: any) => {
        if (addon.ADD_ON_ID === rider.ADD_ON_ID && addon.SUM_INSURED) {
          // setSelectedSumInsuredPA(addon.SUM_INSURED);
          lastSelectedSIRef.current = addon.SUM_INSURED;
        }

        if (!updatedSelectedMembers[addon.ADD_ON_ID]) {
          updatedSelectedMembers[addon.ADD_ON_ID] = addon.selectedMembers || [];
        }
      });

      dispatch(setSelectedMembers(updatedSelectedMembers));
    }
  }, [quote_data, dispatch]);

  const onClick = (selectedMembers?: string[]) => {
    if (isFetching) return null;

    const currentSI = lastSelectedSIRef.current || selectedSumInsuredPA;

    dispatch(
      addOrRemoveRider({
        ...rider,
        selectedMembers: selectedMembers || selected_members_rider[rider.ADD_ON_ID],
        SUM_INSURED: currentSI
      })
    );
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, key_name: string) => {
    const isChecked = e.target.checked;

    const currentSelected = [...(selected_members_rider[rider.ADD_ON_ID] || [])];

    const updatedSelected = isChecked
      ? currentSelected.includes(key_name)
        ? currentSelected
        : [...currentSelected, key_name]
      : currentSelected.filter((name) => name !== key_name);

    const updatedSelectedMembers = {
      ...selected_members_rider,
      [rider.ADD_ON_ID]: updatedSelected,
    };

    dispatch(setSelectedMembers(updatedSelectedMembers));

    const currentSI = lastSelectedSIRef.current || selectedSumInsuredPA;

    // dispatch(addorRemoveMemberRider({
    //   ...rider,
    //   selectedMembers: updatedSelected,
    //   SUM_INSURED: currentSI
    // }));
    if (updatedSelected.length > 0) {
      dispatch(
        addorRemoveMemberRider({
          ...rider,
          selectedMembers: updatedSelected,
          SUM_INSURED: currentSI,
        })
      );
    } else {
      // If no members selected, remove rider
      dispatch(
        addOrRemoveRider({
          ...rider,
          selectedMembers: [],
          SUM_INSURED: currentSI,
        })
      );
    }
  };

  useEffect(() => {
    if (rider.IS_MEMBER_LEVEL === "Y") {
      const selectedMembers = selected_members_rider[rider.ADD_ON_ID];

      if (selectedMembers && selectedMembers.length > 0 && !isRiderSelected) {
        onClick(selectedMembers);
      } else if (isRiderSelected && (!selectedMembers || selectedMembers.length === 0)) {
        onClick();
      }
    }
  }, [selected_members_rider[rider.ADD_ON_ID]?.length, rider]);

  // useEffect(() => {
  //   if (product?.INSURANCE_SLUG === "care") {
  //     if (rider.IS_MANDETORY === "Y" && !isRiderSelected) {
  //       onClick();
  //     }
  //   }
  // }, [rider.IS_MANDETORY, isRiderSelected]);

  return (
    <Box
      width="100%"
      py={2}
      px={1}
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: "5px",
      }}
    >
      <Grid container gap={0.5}>
        <Grid item xs={9}>
          <Typography
            fontSize={{
              xs: "15px",
              sm: "18px",
            }}
            color="text.secondary"
            gutterBottom
          >
            {rider.ADD_ON_NAME}
          </Typography>
          <Typography
            fontSize={{
              xs: "11px",
              sm: "14px",
            }}
          >
            {rider.ADDON_DESCRIPTION}
          </Typography>
          {rider?.VALUE &&
            rider?.ADD_ON_SLUG === "PersonalAccidentOpted" &&
            rider?.IS_MEMBER_LEVEL === "Y" && (
              <RiderSelect
                options={[
                  { code: "0", display_name: "Select" },
                  ...(rider.VALUE.split(",").map((item, index) => {
                    const displayNames =
                      rider?.additionalOptions?.[0]?.options?.split(",") || [];
                    return {
                      code: item.trim(),
                      display_name: displayNames[index]?.trim() || item.trim(),
                    };
                  })),
                ]}
                id={rider.ADD_ON_SLUG}
                label={rider.DROPDOWN_TITLE}
                value={selectedSumInsuredPA}
                handleChange={(e) => {
                  const selectedValue = e.target.value;
                  setSelectedSumInsuredPA(selectedValue);
                  lastSelectedSIRef.current = selectedValue;
                  if (selected_members_rider[rider.ADD_ON_ID]) {
                    dispatch(
                      updateRiderSumInsured({
                        ADD_ON_ID: rider.ADD_ON_ID,
                        SUM_INSURED: selectedValue,
                        rider,
                      })
                    );
                  }
                }}
              />
            )}
          {rider.addon_name === "PEDWP1Y1155" && (
            <RiderSelect
              options={
                rider.ADD_ON_SLUG === "PEDWP1Y1155"
                  ? [
                    { code: "0", display_name: "Select" },
                    ...rider?.VALUE?.split(",").map((item, index) => {
                      const display_names =
                        rider?.additionalOptions?.[0]?.options?.split(
                          ","
                        ) || [];
                      return {
                        code: item,
                        display_name: display_names[index],
                      };
                    }),
                  ] : []
              }
              id={rider.ADD_ON_SLUG}
              label={rider.additionalOptions?.[0].label}
              value={sum_insured || rider?.VALUE?.split(",")[0]}
              handleChange={(e) => {
                dispatch(
                  updateRiderSumInsured({
                    ADD_ON_ID: rider.ADD_ON_ID,
                    SUM_INSURED: e.target.value,
                    rider,
                  })
                );
              }}
            />
          )}

          {rider.IS_MEMBER_LEVEL === "Y" && (
            <Grid container spacing={2} mt={1}>
              {members?.map((member: any) => {
                const key_name = member.count
                  ? member.relation + member.count
                  : member.relation;
                return (
                  <Grid item xs={3} key={key_name}>
                    <input
                      className="custom_checkbox"
                      type="checkbox"
                      id={`${key_name}${rider.ADD_ON_ID}`.replace(/\./g, "")}
                      name={key_name}
                      value={key_name}
                      checked={selected_members_rider[rider.ADD_ON_ID]?.includes(key_name)}
                      onChange={(e) => handleCheckboxChange(e, key_name)}
                    />
                    <label
                      className="custom_checkbox_label"
                      htmlFor={`${key_name}${rider.ADD_ON_ID}`.replace(/\./g, "")}
                    >
                      {key_name}
                    </label>
                  </Grid>
                );
              })}
            </Grid>
          )}

          {/* {rider.VALUE && rider.ADD_ON_SLUG === "Deductible" && (
            <RiderSelect
              options={
                [
                  { code: "0", display_name: "Select" },
                  ...rider?.VALUE?.split(",").map((item, index) => {
                    const display_names =
                      rider?.additionalOptions?.[0]?.options?.split(",") || [];
                    return {
                      code: item,
                      display_name: display_names[index] || item,
                    };
                  }),
                ]
              }
              id={rider.ADD_ON_SLUG}
              label={rider.DROPDOWN_TITLE}
              value={selectedRider?.SUM_INSURED || rider?.VALUE?.split(",")[0]}
              handleChange={(e) => {
                const selectedValue = e.target.value;
                dispatch(
                  updateRiderSumInsured({
                    ADD_ON_ID: rider.ADD_ON_ID,
                    SUM_INSURED: selectedValue,
                    rider: {
                      ...rider,
                      SUM_INSURED: selectedValue
                    },
                  })
                );

                // if (isRiderSelected) {
                //   dispatch(
                //     addOrRemoveRider({
                //       ...rider,
                //       SUM_INSURED: selectedValue
                //     })
                //   );
                // }
              }}
            />
          )} */}
          {rider.VALUE && rider?.ADD_ON_SLUG !== "PEDWP1Y1155" && rider?.ADD_ON_SLUG !== "PersonalAccidentOpted" && (
            <RiderSelect
              options={[
                { code: "0", display_name: "" },
                ...rider?.VALUE?.split(",").map((item, index) => {
                  const display_names =
                    rider?.additionalOptions?.[0]?.options?.split(",") || [];
                  return {
                    code: item.trim(),
                    display_name: (display_names[index] || item).trim(),
                  };
                }),
              ]}
              id={rider.ADD_ON_SLUG}
              label={rider.DROPDOWN_TITLE}
              value={(selectedRider?.SUM_INSURED || rider?.VALUE?.split(",")[0])?.trim()}
              handleChange={(e) => {
                const selectedValue = e.target.value;
                dispatch(
                  updateRiderSumInsured({
                    ADD_ON_ID: rider.ADD_ON_ID,
                    SUM_INSURED: selectedValue,
                    rider: {
                      ...rider,
                      SUM_INSURED: selectedValue,
                    },
                  })
                );

                // if (isRiderSelected) {
                //   dispatch(
                //     addOrRemoveRider({
                //       ...rider,
                //       SUM_INSURED: selectedValue
                //     })
                //   );
                // }
              }}
            />
          )}

        </Grid>

        <Grid item xs={2.8}>
          <Button
            variant="outlined"
            color="primary"
            sx={{
              marginRight: 2,
              fontWeight: "500",
              width: "100%",
              justifyContent: isFetching ? "center" : "flex-start",
              background:
                rider.IS_MANDETORY === "Y" || isRiderSelected
                  ? "#D3ECF1"
                  : "",
              fontSize: {
                xs: "12px",
                sm: "15px",
              },
            }}
            disabled={rider.IS_MANDETORY === "Y" || isDisabled || !isEnabled}
            onClick={() => {
              onClick(selected_members_rider[rider.ADD_ON_ID]);
            }}
          >
            {isFetching ? (
              <CircularProgress />
            ) : (
              <>
                <Checkbox
                  checked={
                    rider.IS_MANDETORY === "Y" ||
                    isRiderSelected
                  }
                />
                {!!Number(rider.premium) &&
                  Number(rider.premium).toLocaleString("en-IN")}
              </>
            )}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RiderCard;